import { Button } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Grid from '../../components/Grid/Grid';
import { LoadingSpinnerWithContent } from '../../components/LoadingSpinnerWithContent/LoadingSpinnerWithContent';
import { useStore } from '../../hooks/use-store';
import './ConnectPractice.scss';
import { SubRowRenderer } from './renderers';

const ConnectPractice = observer(() => {
  const { connectPracticeStore: store, globalStore } = useStore();
  const navigate = useNavigate();
  const { loaders, colDefs, expandedRowIds } = store;

  useEffect(() => {
    store.init();
  }, [store]);

  return (
    <div className='connect-practice_wrapper'>
      <div className='spot-typography__heading--level-2'>Connect your Practice with Trupanion</div>
      <div className='spot-typography__text--tertiary'>
        This data gets refreshed every 12 hours.
      </div>
      <div className='spot-typography__text--tertiary'>
        <a
          href='https://vet.trupanion.com/automated-offers-info'
          target='_blank'
          rel='noopener noreferrer'
        >
          Learn more
        </a>{' '}
        about how Trupanion can help increase your insured client base and connect with confidence.
        When you click Connect, you agree to the terms and conditions of this program found on the
        Learn more page.
      </div>
      {globalStore.practices.length === 0 && (
        <Button
          className='retrieve-practices-btn'
          variant='primary'
          size='small'
          disabled={loaders.retrieve}
          onClick={() => void store.retrievePractices()}
          data-testid='retrieve-practices-btn'
        >
          Retrieve Practices
        </Button>
      )}
      {loaders.retrieve && (
        <LoadingSpinnerWithContent size='large'>
          One moment while we retrieve your practices from your local Cornerstone Server.
        </LoadingSpinnerWithContent>
      )}
      {!loaders.retrieve && globalStore.practicesRetrieved && (
        <Grid
          id='practices-grid'
          columns={colDefs}
          data={globalStore.practices}
          expandedRowIds={expandedRowIds}
          rowIdField='id'
          subrowRenderer={SubRowRenderer}
        />
      )}
      <div className='page-bottom-actions'>
        <Button
          variant='link'
          size='small'
          className='back'
          onClick={() => void navigate(-1)}
          data-testid='back-btn'
        >
          Back
        </Button>
        <div>
          <Button
            variant='secondary'
            size='small'
            data-testid='dashboard-btn'
            onClick={() => void navigate('/')}
          >
            Dashboard
          </Button>
          <Button
            variant='primary'
            size='small'
            disabled={
              !globalStore.practicesRetrieved || !globalStore.practicesConnected || loaders.connect
            }
            onClick={() => store.navigateToOffersPage()}
            data-testid='offers-setup-btn'
          >
            Offer Setup
          </Button>
        </div>
      </div>
    </div>
  );
});

export default ConnectPractice;
